import { render, staticRenderFns } from "./daping.vue?vue&type=template&id=4c52249c&scoped=true&"
import script from "./daping.vue?vue&type=script&lang=js&"
export * from "./daping.vue?vue&type=script&lang=js&"
import style0 from "./daping.vue?vue&type=style&index=0&id=4c52249c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c52249c",
  null
  
)

export default component.exports